/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var bluetoothlist = "";
  var paperlist = "";
  var paperSize = [57, 80];
  var checked = "";
  var version = "";
  var user = localStorage.getItem("username");
  var uuid = "";
  var currentVersion = window.version; // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  for (var i = 0; i < paperSize.length; i++) {
    checked = "";
    if (localStorage.getItem("paperSize") == i) checked = "checked";
    paperlist += "\n    <li>\n      <label class=\"item-radio item-radio-icon-end item-content\">\n        <input type=\"radio\" name=\"paperSize\" class=\"paperSize\" value=\"" + i + "\" " + checked + " />\n        <i class=\"icon icon-radio\"></i>\n        <div class=\"item-inner\">\n          <div class=\"item-title\">" + paperSize[i] + " mm</div>\n        </div>\n      </label>\n    </li>\n    ";
  }

  var logout = function logout() {
    console.log("logout");
    localStorage.setItem("username", "");
    localStorage.setItem("password", "");
    localStorage.setItem("nickname", "");
    $f7.tab.show("#view-home", true);
    if (window.service == "agent") $f7.views.main.router.navigate("/agent_home/", {
      reloadCurrent: true,
      force: true
    });
    if (window.service == "cashier") $f7.views.main.router.navigate("/cashier_home/", {
      reloadCurrent: true,
      force: true
    });
  };

  $update();
  $(document).on('click', '.paperSize', function (e) {
    localStorage.setItem("paperSize", $('input[name="paperSize"]:checked').val());
  });

  var onSuccess = function onSuccess(data) {
    alert('message: ' + data.message);
  };

  function onError(error) {
    alert('message: ' + error.message);
  }

  var updateSystem = function updateSystem() {
    if ($f7.device.cordova == true) {
      if (window.updateFile != undefined) {
        $f7.dialog.alert("Downloading system update...");
      } else {
        $f7.dialog.alert("Unable to download...");
        return;
      } //cordova.InAppBrowser.open(window.updateFile,'_system', 'location=yes');


      var fileTransfer = new FileTransfer();
      var uri = encodeURI(window.updateFile);
      var fileURL = "cdvfile://localhost/persistent/path/to/downloads/test.apk";
      fileTransfer.download(uri, fileURL, function (entry) {
        console.log("download complete: " + entry.toURL());
        cordova.plugins.fileOpener2.open(fileURL, 'application/vnd.android.package-archive');
      }, function (error) {
        $f7.dialog.alert("Install failed...");
        console.log("Download error code:" + error.code);
      });
    } else window.open(window.updateFile);
  };

  $on('pageInit', function () {
    setInterval(function () {
      //FIRESTORE
      var docRef = db.collection("system").doc(window.service);
      docRef.get().then(function (doc) {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          window.updateFile = doc.data().url;
          version = doc.data().version;
          $update();
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      }).catch(function (error) {
        console.log("Error getting document:", error);
      });
    }, 5000);
    uuid = window.uuid;
    $update();

    if (!window.DatecsPrinter) {
      if ($f7.device.cordova) alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        // Check if printer has been set or not
        if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); //List down the printer for printing

        for (var i = 0; i < devices.length; i++) {
          checked = "";
          if (localStorage.getItem("printer") == i) checked = "checked";
          bluetoothlist += "\n            <li>\n              <label class=\"item-radio item-radio-icon-end item-content\">\n                <input type=\"radio\" name=\"printer\" class=\"printer\" value=\"" + i + "\" " + checked + " />\n                <i class=\"icon icon-radio\"></i>\n                <div class=\"item-inner\">\n                  <div class=\"item-title\">" + devices[i].name + "</div>\n                </div>\n              </label>\n            </li>\n            ";
        }

        $update();
        $(document).on('click', '.printer', function (e) {
          localStorage.setItem("printer", $('input[name="printer"]:checked').val());
        });
      }, function (error) {
        alert(JSON.stringify(error));
      });
    }
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="settings">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="title">Settings</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">Select printer</div>

    <div class="list inset">
      <ul innerHTML=${bluetoothlist}>
      </ul>
    </div>

    <div class="block-title">Select printing paper size</div>

    <div class="list inset">
      <ul innerHTML=${paperlist}>
      </ul>
    </div>  



  </div>
</div>
`
    }
    ;
}

framework7Component.id = 'cb5ae88111';
export default framework7Component;